/* Raghu  26/10/2022   3075154998   Input Field Enhancements */
/* Rohini  26/10/2022   3075154998   Text Field Enhancements
Suresh Peddavoora 11/03/2022 3075154998 Text fields Tab Responsive Fixes

*/

import React, {useEffect, useState, useContext} from 'react';
import {Form, Formik} from 'formik';
import {Button, Grid, TextField, FormHelperText} from '@material-ui/core';
import {
  resetData,
  resetMessage,
} from '../../../../redux/reducers/EnableFramework/Filter';
import FilterSearchTable from './FilterSearchTable';
import {ThemeContext} from '../../../../themes/ThemeProvider';
import {useDispatch, useSelector} from 'react-redux';
import {
  SuccessSnackbar,
  ErrorSnackbar,
  WarningSnackbar,
} from '../../../../components/CustomSnackBar';
import * as Yup from 'yup';

const FilterSearch = ({
  setValueCode,
  setFilterCode,
  setFilterCodeName,
  setIsCopyRowData,
  setUsageState,
  setFieldRowData,
  fieldRowData,
}) => {
  const dispatch = useDispatch();
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const [searchData, setSearchData] = useState([]);
  const [submit, setSubmit] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [customError, setCustomError] = useState(false);
  const [isDelete, setIsDelete] = useState(false);
  const {FilterPrintStatus, isLoading, successMsg, errorMsg, usageFilter} = useSelector(
    ({filter}) => filter,
  );
  const [isUsage, setIsUsage] = useState(false);
  const schema = Yup.object().shape({
    name: Yup.string().matches(
      /^[a-zA-Z0-9]+$/,
      'White space and special character are not allowed',
    ),
  });

  const initialValues = {
    name: '',
    description: '',
  };

  const onClear = () => {
    const data = {
      name: '',
      description: '',
    };
    setSearchData(data);
  };

  const handleSubmit = (data) => {
    setSearchData(data);
    setSubmit(true);
  };
  useEffect(() => {
    if (usageFilter?.userMetrix === 'No') {
      deleteUsage ? setUserMetrixDelete(false) : setCustomError(true);
      deleteUsage && setIsDelete(true);
      setTimeout(() => {
        setCustomError(false);
      }, 3000);
    } else if (usageFilter?.userMetrix === 'Yes') {
      deleteUsage && setIsUsage(true);
      deleteUsage && setUserMetrixDelete(true);
      !deleteUsage && setValueCode(2);
    }
  }, [usageFilter]);

  useEffect(() => {
    setValueCode(0);
    setIsDelete(false);
    setCustomError(false);
  }, []);

  useEffect(() => {
    setFilterCode('');
    setFilterCodeName('');
    dispatch(resetData());
  }, []);
  useEffect(() => {
    if (FilterPrintStatus && FilterPrintStatus === 200) {
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [FilterPrintStatus]);
  return (
    <>
      <div className={`mb-0`}>
        <Formik
          onSubmit={(values) => handleSubmit(values)}
          initialValues={initialValues}
          validationSchema={schema}
          enableReinitialize
        >
          {(props) => {
            const {touched, errors, values, handleChange, handleBlur, handleReset} = props;
            return (
              <Form autoComplete="off" noValidate>
                <Grid className="form-row global-field-textfields" container spacing={2}>
                  <Grid item xs={3} md={4} sm={6} xl={3} className="form-group">
                    <TextField
                      className={` ${classes.labelName} ${classes.inputLabel}`}
                      margin="dense"
                      variant="standard"
                      placeholder={`Enter Filter Code`}
                      label="Filter Codes"
                      name="name"
                      value={values?.name?.toUpperCase()}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                      touched={touched.name}
                      error={Boolean(touched.name && errors.name)}
                    />
                    <FormHelperText>{touched.name && errors.name && errors.name} </FormHelperText>
                  </Grid>
                  <Grid item xs={3} md={5} sm={6} xl={6} className="form-group">
                    <TextField
                      className={` ${classes.labelName} ${classes.inputLabel}`}
                      margin="dense"
                      variant="standard"
                      name="description"
                      placeholder={`Enter Description`}
                      label="Description"
                      value={values.description}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      fullWidth
                    />
                  </Grid>
                  <Grid item xs={3} md={3} sm={6} xl={3} className="form-group">
                    <div className="d-flex justify-content-end">
                      <Button
                        variant="outlined"
                        className={`reset-btn mx-1 ${classes.buttonRoot}`}
                        onClick={() => {
                          handleReset();
                          setSearchData({});
                          setSubmit(true);
                          onClear();
                        }}
                      >
                        Clear
                      </Button>
                      <Button
                        variant="outlined"
                        type="submit"
                        className={`search-btn mx-1 ${classes.buttonRoot}`}
                      >
                        Search
                      </Button>
                    </div>
                  </Grid>
                </Grid>
              </Form>
            );
          }}
        </Formik>
        <Grid>
          <FilterSearchTable
            searchData={searchData}
            setFilterCode={setFilterCode}
            setValueCode={setValueCode}
            setFilterCodeName={setFilterCodeName}
            submit={submit}
            setSubmit={setSubmit}
            setIsCopyRowData={setIsCopyRowData}
            isLoading={isLoading}
            userMetrixDelete={userMetrixDelete}
            isDelete={isDelete}
            setIsDelete={setIsDelete}
            deleteUsage={deleteUsage}
            setDeleteUsage={setDeleteUsage}
            fieldRowData={fieldRowData}
            setFieldRowData={setFieldRowData}
            isUsage={isUsage}
            setIsUsage={setIsUsage}
          />
        </Grid>
        {customError && (
          <WarningSnackbar errorMsg={'This logic block is not being used anywhere'} />
        )}
      </div>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};
export default FilterSearch;
